<template>
  <SHeaderBase>
    <template #right>
      <SButton
        action-type="tertiary-soft"
        :href="ziggyUnsafe('auth.login', undefined, { project: 'customer' })"
        size="sm"
      >
        {{ tr("main_site.layout.header_login_pro") }}
      </SButton>
    </template>
  </SHeaderBase>
</template>

<script setup lang="ts">
import { SButton } from "@solvari/common-fe";
import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSiteLayout } from "@solvari/translations";

import SHeaderBase from "./SHeaderBase.vue";

const { tr } = useI18nMainSiteLayout();
</script>
